module.exports = __webpack_public_path__ + "static/media/behavioral-science.dded3e47.svg";